import React, { useState } from "react";
import Section from "@/components/ui/section";
import Image from "next/image";
import Link from "next/link";
import useScreenSize from "@/utils/use-screen-size";
export default function Partners({ clients }) {
  const [open, setOpen] = useState(false);
  const { width } = useScreenSize();
  const displayedClients = open
    ? clients
    : clients.slice(
        0,
        width >= 991 ? 10 : width >= 767 && width < 991 ? 8 : 10
      );

  return (
    <Section className="bg-[#f6f5f1] max-w-[1366px] mx-auto">
      <h5 className="text-[#292929]/70 text-center font-havletica">
        Our Clients
      </h5>
      <div className="grid lg:grid-cols-5 md:grid-cols-4 grid-cols-2 auto-rows-auto gap-0 mt-8">
        {displayedClients?.map((partner, key) => (
          <div
            className="w-full flex items-center justify-center"
            key={"partner" + key}
          >
            <div className="relative lg:w-[200px] lg:h-[140px] md:w-[200px] md:h-[200px] w-[200px] h-[120px]">
              <Image
                src={partner?.image.data.attributes.url}
                alt={partner?.title}
                sizes="(max-width: 479px) 500px, 500px"
                fill
                className="w-full h-full object-contain object-center"
              />
            </div>
          </div>
        ))}
      </div>
      {clients?.length > 10 && (
        <div
          onClick={() => setOpen(!open)}
          className="mt-10 mx-auto cursor-pointer text-sm underline text-darkGrey hover:text-darkGrey/50 transition-all duration-300 ease w-fit"
        >
          {!open ? "View More" : "View less"}
        </div>
      )}
    </Section>
  );
}
